/**
 * Non-empty trim filter for `MarketingCampaign.publish_errors`, aligned with Algolia ad-campaign indexing
 * (`algoliaService` → `mapMarketingCampaignToAlgoliaAdCampaignObject`).
 */
export function normalizeCampaignPublishErrors(
  publish_errors: string[] | undefined | null
): string[] {
  return publish_errors?.filter((error) => error.trim().length > 0) ?? [];
}
